import {injectable} from 'inversify';

import {ProgramDurationModel} from './ProgramDuration.model';

@injectable()
export class ProgramDurationFactory {
  create(value: number): ProgramDurationModel {
    return new ProgramDurationModel(value);
  }
}
